import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=16a7fba0&scoped=true&"
import script from "./OrganisationSelector.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSelector.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationSelector.vue?vue&type=style&index=0&id=16a7fba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7fba0",
  null
  
)

export default component.exports